const validateArn = (arn: string): boolean => {
  return (
    typeof arn === "string" &&
    arn.indexOf("arn:") === 0 &&
    arn.split(":").length >= 6
  );
};

export { validateArn };
